<template>
  <div>
    <div class="d-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-right">
      <div style="margin-top: 5px">
        <el-button @click="search">查询</el-button>
        <el-button @click="excelOweOrder">导出欠费账单</el-button>
        <el-button @click="exportOrder">导入挂账订单</el-button>
        <el-button @click="verificationBill">账单核销</el-button>
        <el-button @click="cancelBill">取消挂账</el-button>
        <el-button @click="makeInvoice">开票</el-button>
      </div>
      <el-descriptions :column="2" size="mini" border style="margin-top: 8px">
        <el-descriptions-item label="房产/项目">
          <el-input
            v-model="form.houseName"
            size="mini"
            placeholder="输入房产或项目名称搜索"
          />
        </el-descriptions-item>
        <el-descriptions-item label="计费周期">
          <el-date-picker
            v-model="startDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择开始日期"
          />
          至
          <el-date-picker
            v-model="endDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择结束日期"
          />
        </el-descriptions-item>
        <el-descriptions-item label="收费项目">
          <el-select
            v-model="form.chargeItemId"
            size="mini"
            filterable
            clearable
            multiple
            style="width: 70%"
            placeholder="选择收费项目"
          >
            <el-option
              size="mini"
              v-for="item in chargeitem"
              :key="item.id"
              :label="item.chargeItem_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="挂账状态">
          <el-select
            v-model="form.status"
            size="mini"
            filterable
            clearable
            style="width: 70%"
            placeholder="选择挂账状态"
          >
            <el-option
              size="mini"
              v-for="item in billingStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="挂账时间">
          <el-date-picker
            v-model="billingStart"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择开始日期"
          />
          至
          <el-date-picker
            v-model="billingEnd"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择结束日期"
          />
        </el-descriptions-item>
      </el-descriptions>
      <el-table
        max-height="750px"
        :data="listData"
        border
        style="margin-top: 8px"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="房产" prop="h_name_date" />
        <el-table-column label="收费项目" prop="charge_name" />
        <el-table-column label="计费周期" prop="calc" />
        <el-table-column label="欠费金额" prop="oweMoney" />
        <el-table-column label="挂账金额" prop="collection_amount" />
        <el-table-column label="状态" prop="statusTxt" />
        <el-table-column label="挂账时间" prop="create_at" />
        <el-table-column label="核销时间" prop="verification_at" />
        <el-table-column label="是否开票" prop="invoice_status">
          <template slot-scope="data">
            {{ data.row.invoice_status === 0 ? "未开票" : "已开票" }}
          </template>
        </el-table-column>
        <el-table-column label="操作"> </el-table-column>
      </el-table>
      <el-pagination
        style="float: right; margin-top: 10px; margin-right: 20px"
        background
        :small="true"
        layout="prev, pager, next"
        :page-size="form.pageSize"
        :total="totalCount"
        :current-page.sync="form.page"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="导入文件"
      :visible.sync="dialogImportModel"
      width="60%"
      :before-close="handleImportClose"
      v-loading="loading"
    >
      <el-upload
        :action="url"
        :before-remove="beforeRemove"
        :on-success="handleAvatarSuccess"
        accept=".xls,.xlsx"
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload"
      >
        <el-button size="small" type="primary"> 点击上传 </el-button>
        <div slot="tip">只能上传xls或xlsx文件，且不超过8M</div>
      </el-upload>
      <el-button size="mini" @click="delNode"> 删除 </el-button>
      <el-button size="mini" @click="importExcelData"> 导入 </el-button>
      <el-table
        max-height="450px"
        :data="importData"
        border
        style="margin-top: 8px"
        @selection-change="handleSelectionChangeImport"
      >
        <el-table-column prop="id" label="订单ID" />
        <el-table-column prop="houseName" label="房号" />
        <el-table-column prop="calcDate" label="计费周期" />
        <el-table-column prop="chargePay" label="应收金额" />
        <el-table-column prop="charge" label="实际应收" />
        <el-table-column prop="chargePaid" label="已缴金额" />
        <el-table-column prop="discount" label="减免金额" />
        <el-table-column prop="oweMoney" label="欠费金额" />
        <el-table-column prop="billCollection" label="挂账金额" />
      </el-table>
    </el-dialog>

    <el-dialog
      title="开具电子发票"
      :visible.sync="dialogButton"
      width="60%"
      :before-close="handleCloseInvoice"
      v-loading="loading"
    >
      <el-form
        ref="form"
        :model="invoiceForm"
        label-width="120px"
        :rules="rules"
      >
        <el-form-item label="发票抬头" prop="title">
          <el-input v-model="invoiceForm.title" />
        </el-form-item>
        <el-form-item label="纳税人识别号">
          <el-input v-model="invoiceForm.taxNo" />
        </el-form-item>
        <el-form-item label="地址、电话">
          <el-input v-model="invoiceForm.address" />
        </el-form-item>
        <template v-if="!isDigitization">
          <el-form-item label="开户行及账号" prop="bank">
            <el-input v-model="invoiceForm.bank" />
          </el-form-item>
          <el-form-item label="电话/邮箱" prop="phone">
            <el-input v-model="invoiceForm.phone" />
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="开户行" prop="bank">
            <el-input v-model="invoiceForm.bank" />
          </el-form-item>
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input v-model="invoiceForm.bankAccount" />
          </el-form-item>
          <el-form-item label="电话" prop="mobile">
            <el-input v-model="invoiceForm.phone" />
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="invoiceForm.email" />
          </el-form-item>
        </template>
        <el-form-item label="备注">
          <el-input v-model="invoiceForm.remark" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="issueInvoice">保存</el-button>
          <el-button @click="handleCloseInvoice">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ErpTree from "@/components/Admin/Common/erp-tree";
import imgurl from "@/assets/js/imgurl.js";
export default {
  name: "billCollection",
  components: {
    ErpTree,
  },
  data() {
    return {
      form: {
        page: 1,
        pageSize: 10,
        pid: 0,
        houseName: "",
        houseId: 0,
        startDate: "",
        endDate: "",
        chargeItemId: [],
        billingStart: "",
        billingEnd: "",
        status: "",
      },
      startDate: "",
      endDate: "",
      billingStart: "",
      billingEnd: "",
      chargeitem: [],
      loading: false,
      importData: [],
      multipleSelection: [],
      fileList: [],
      dialogImportModel: false,
      url: "",
      listData: [],
      billingStatus: [
        { label: "全部", value: "" },
        { label: "挂账中", value: "1" },
        { label: "已销帐", value: "-1" },
        { label: "已核销", value: "2" },
      ],
      orderIds: [],
      datas: [],
      invoiceForm: {
        orderIds: [],
        title: "",
        phone: "",
        taxNo: "",
        address: "",
        remark: "",
        bank: "",
        bankAccount: "",
        email: "",
        ids: [],
      },
      rules: {
        title: [{ required: true, message: "请填写发票抬头", trigger: "blur" }],
        phone: [
          { required: true, message: "请填写电话/邮箱", trigger: "blur" },
        ],
      },
      isDigitization: false,
      dialogButton: false,
      totalCount: 0
    };
  },
  mounted() {
    //加载收费大类（费项）
    this.$myhttp
      .get("admin/common/getChargeitem", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    var oa_user_id = window.localStorage.getItem("oa_user_id");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/BillCollection/importExcel?" +
      "login_name=" +
      login +
      "&token=" +
      token +
      "&oa_user_id=" +
      oa_user_id;
  },
  watch: {
    "form.page"(n) {
      this.search();
    },
    "form.pageSize"(n) {
      this.search();
    },

    dialogButton(n, o) {
      if (n === true) {
        this.checkIsDigitization();
      }
    },
  },
  methods: {
    nodeClick(data) {
      this.form.pid = data.tree[0].projectId;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.form.houseName = tree_str;
      if (data.type === "room") {
        this.form.houseId = data.id;
      } else {
        this.form.houseId = "";
      }
    },
    search() {
      if (this.form.pid == "" || this.form.pid == 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.form.billingStart = this.billingStart / 1000;
      this.form.billingEnd = this.billingEnd / 1000;
      this.loading = true;
      this.$myhttp
        .post("admin/BillCollection/index", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loading = false;
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    excelOweOrder() {
      if (this.form.pid == "" || this.form.pid == 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.loading = true;
      this.$myhttp
        .post("admin/BillCollection/exportOweMoney", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            let url = imgurl + backdata.data.data;
            this.loading = false;
            window.open("/office.html#/office?url=" + url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.importData = [];
        })
        .catch(() => {});
    },
    handleAvatarSuccess(response, file, fileList) {
      if (response.code == 200) {
        this.importData = response.data.length > 0 ? response.data : [];
      } else {
        this.$message.error(response.msg);
      }
    },
    //超过一个文件
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //限制大小
    beforeAvatarUpload(file) {
      const isLt7M = file.size / 1024 / 1024 < 8;
      if (!isLt7M) {
        this.$message.error("上传文件大小不能超过 8MB!");
      }
      return isLt7M;
    },
    handleSelectionChangeImport(val) {
      this.multipleSelection = val;
    },
    delNode() {
      if (this.multipleSelection.length == 0) {
        return;
      }
      let data = [];
      if (this.importData.length == this.multipleSelection.length) {
        this.importData = [];
        this.multipleSelection = [];
      } else {
        this.importData.map((req) => {
          let bool = true;
          this.multipleSelection.map((reqs) => {
            if (req.id == reqs.id) {
              bool = false;
            }
          });
          if (bool) {
            data.push(req);
          }
        });
      }
      this.importData = data;
    },
    exportOrder() {
      this.dialogImportModel = true;
    },
    importExcelData() {
      this.loading = true;
      this.$myhttp
        .post(
          "admin/BillCollection/importExcelData",
          { data: this.importData },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
            this.loading = false;
            this.handleImportClose();
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
          this.loading = false;
        });
    },
    handleImportClose() {
      this.dialogImportModel = false;
    },

    handleSelectionChange(val) {
      this.datas = val;
      let oids = [];
      this.datas.map((req) => {
        oids.push(req.order_id);
      });
      let ids = [];
      this.datas.map((req) => {
        ids.push(req.id);
      });
      this.orderIds = oids;
      this.invoiceForm.ids = ids;
    },

    verificationBill() {
      if (this.form.pid == "" || this.form.pid == 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.loading = true;
      this.$myhttp
        .post(
          "admin/BillCollection/verification",
          { pid: this.form.pid, orderIds: this.orderIds },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
          this.loading = false;
        });
    },

    cancelBill() {
      if (this.form.pid == "" || this.form.pid == 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.loading = true;
      this.$myhttp
        .post(
          "admin/BillCollection/cancel",
          { pid: this.form.pid, orderIds: this.orderIds },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
          this.loading = false;
        });
    },
    handleCloseInvoice() {
      this.dialogButton = false;
    },
    issueInvoice() {
      this.loading = true;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.invoiceForm.pid = this.form.pid;
          this.$myhttp
            .post("admin/Invoice/issueInvoiceBill", this.invoiceForm, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg);
                this.loading = false;
                this.handleCloseInvoice();
              } else {
                this.$message.error(backdata.data.msg);
                this.loading = false;
              }
            })
            .catch((err) => {
              this.$message.error(err);
              this.loading = false;
            });
        } else {
          this.loading = false;
        }
      });
    },
    makeInvoice() {
      if (this.form.pid == "" || this.form.pid == 0) {
        this.$message.error("请选择项目");
        return;
      }
      if (this.orderIds.length == 0) {
        this.$Message.error("请选择开票挂账单");
      } else {
        this.dialogButton = true;
        this.invoiceForm.orderIds = this.orderIds;
      }
    },
    checkIsDigitization() {
      this.$myhttp
        .post(
          "admin/InvoiceDisc/checkIsDigitization",
          { pid: this.form.pid },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.isDigitization = backdata.data.data.is_digitization;
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style>
.d-left {
  border-right: 1px solid #eee;
  width: 250px;
  float: left;
}
.d-right {
  float: right;
  width: calc(100% - 253px);
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Order/billCollection.vue